import validationRules, { createValidationRule, allValidationRules } from './validationRules';
import getCountryCode from '../i18n/getCountryCode';
import validate from 'validate.js';
import serialize from '../form/serialize';
import pick from 'lodash/pick';
import isFieldVisible from '../selectors/isFieldVisible';

const visibleFieldsSelector = [
  '.lead-constructor__panel.active input',
  '.lead-constructor__panel.active select'
].join(', ');

export function visibleFields(form) {
  return [...form.querySelectorAll(visibleFieldsSelector)]
    .filter((field) => isFieldVisible(field));
}

export function applyInputValidation(input, message) {
  const errorSpan = input.parentNode.querySelector('.form__error');
  if (input.classList.contains('input--error') && errorSpan) {
    errorSpan.innerHTML = message;
  } else {
    const el = document.createElement('span');
    el.className = 'form__error';
    el.innerHTML = message;
    input.classList.add('input--error');
    input.classList.add('js-input-validated');
    input.parentNode.appendChild(el);
  }
}

export function buildRules(form) {
  const countryCode = getCountryCode();
  const visibleFieldNames = visibleFields(form).map(field => field.name);
  return pick(validationRules(countryCode), visibleFieldNames);
}

export function applyValidation(form, results) {
  visibleFields(form).forEach(input => {
    if(results[input.name]) {
      const message = results[input.name][0];
      applyInputValidation(input, message);
    } else {
      unapplyInputValidation(input);
    }
  });
}

export function unapplyInputValidation(input) {
  input.classList.remove('input--error');
  input.classList.add('js-input-validated');
  const message = input.parentNode.querySelector('.form__error');
  if(message) message.remove();
}

export default function(form) {
  const serializedForm = serialize(form);
  const rules = buildRules(form);
  const results = validate(serializedForm, rules);
  applyValidation(form, results || {});
  return !results;
}

// This method a list of errors if the field is invalid otherwise nothing
export function validateField(fieldName, value) {
  const rule = createValidationRule(fieldName);
  const result = validate.single(value, rule);
  return result;
}

export function validateAllFields(form){
  const serializedForm = serialize(form);
  const rules = getAllRules(form);
  const results = validate(serializedForm, rules);
  applyValidation(form, results || {});
  return !results;
}

export function getAllRules(form) {
  const countryCode = getCountryCode();
  const visibleFieldNames = visibleFields(form).map(field => field.name);
  return pick(allValidationRules(countryCode), visibleFieldNames);
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/validation/validateForm.js